<template>
  <!-- 半透明遮罩，点击空白处关闭 -->
  <transition name="ad-fade">
    <div class="giftAdMask" v-if="visible" @click.self="close">
      <!-- 广告卡片 -->
      <transition name="ad-pop" appear>
        <div class="giftAdCard" v-if="visible && adData" @click="onTapAd">
          <!-- 关闭按钮 -->
          <div class="ga_close" @click.stop="close">×</div>

          <!-- 商品图 -->
          <div class="ga_img_wrap">
            <img class="ga_img" :src="adData.image" />
            <!-- 闪烁光效角标 -->
            <div class="ga_shine"></div>
          </div>

          <!-- 文案 -->
          <div class="ga_body">
            <div class="ga_tag">🎉 生日惊喜</div>
            <div class="ga_name">{{ adData.storeName }}</div>
            <div class="ga_price">
              <span class="ga_symbol">¥</span>{{ adData.price }}
            </div>
          </div>

          <!-- CTA 按钮（自带呼吸动画） -->
          <div class="ga_cta">点我送出 ></div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
export default {
  name: "GiftAdPopup",
  data() {
    return {
      visible: false,
      adData: null,
      productId: ""
    };
  },
  methods: {
    /* ============ 对外 API ============ */
    // 传入商品 ID：拉详情 → 展示广告
    open(productId) {
      if (!productId) return;
      this.productId = productId;
      this.fetchAd();
    },

    close() {
      this.visible = false;
      this.adData = null;
      this.$emit("closed");
    },

    // 点击广告 → 关广告、通知父级打开商品详情
    onTapAd() {
      const id = this.productId;
      this.visible = false;
      this.adData = null;
      this.$emit("tapped", id);
    },

    /* ============ 拉商品信息做广告素材 ============ */
    fetchAd() {
      this.$http
          .get(`/api/product/detail/${this.productId}`)
          .then(res => {
            const body = res.data || {};
            const data = body.data || body;
            const storeInfo = data.storeInfo || {};

            // 轮播第一张做主图
            let image = storeInfo.image || "";
            if (storeInfo.sliderImageArr && storeInfo.sliderImageArr.length) {
              image = storeInfo.sliderImageArr[0];
            } else if (storeInfo.sliderImage) {
              image = String(storeInfo.sliderImage).split(",")[0];
            }

            this.adData = {
              image,
              storeName: storeInfo.storeName || "神秘好礼",
              price: storeInfo.price || ""
            };
            this.visible = true;
          })
          .catch(() => {
            // 详情拉失败就不弹广告，静默
          });
    }
  }
};
</script>

<style lang="less" scoped>
/* 遮罩：半透明黑，能透出直播间画面 */
.giftAdMask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.55); /* ✅ 半透明 */
  z-index: 2005; /* 高于聊天输入层，低于 GoodsPopup 本身 */
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 广告卡片 */
.giftAdCard {
  position: relative;
  width: 300px;
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.35);
  text-align: center;

  .ga_close {
    position: absolute;
    top: 8px;
    right: 8px;
    width: 26px;
    height: 26px;
    line-height: 24px;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.45);
    color: #fff;
    font-size: 18px;
    z-index: 2;
  }

  /* 商品图 */
  .ga_img_wrap {
    position: relative;
    width: 100%;
    height: 220px;
    overflow: hidden;

    .ga_img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }

    /* 划过的高光 */
    .ga_shine {
      position: absolute;
      top: 0;
      left: -80%;
      width: 50%;
      height: 100%;
      background: linear-gradient(
          105deg,
          transparent 40%,
          rgba(255, 255, 255, 0.45) 50%,
          transparent 60%
      );
      animation: adShine 2.5s ease-in-out infinite;
    }
  }

  /* 文案区 */
  .ga_body {
    padding: 12px 14px 4px;

    .ga_tag {
      display: inline-block;
      font-size: 12px;
      color: #fff;
      background: linear-gradient(90deg, #ff6a9a, #ff3b6b);
      padding: 2px 10px;
      border-radius: 999px;
      margin-bottom: 6px;
    }

    .ga_name {
      font-size: 16px;
      font-weight: 600;
      color: #222;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .ga_price {
      margin-top: 2px;
      color: #d0173c;
      font-size: 22px;
      font-weight: 700;

      .ga_symbol {
        font-size: 13px;
      }
    }
  }

  /* CTA 呼吸按钮 */
  .ga_cta {
    margin: 10px 14px 14px;
    height: 42px;
    line-height: 42px;
    border-radius: 999px;
    color: #fff;
    font-size: 15px;
    font-weight: 600;
    background: linear-gradient(90deg, #ff6a9a, #d0173c);
    animation: adBreath 1.2s ease-in-out infinite;
  }
}

/* ============ 动画 ============ */
/* 遮罩淡入淡出 */
.ad-fade-enter-active,
.ad-fade-leave-active {
  transition: opacity 0.25s ease;
}
.ad-fade-enter,
.ad-fade-leave-to {
  opacity: 0;
}

/* 卡片弹出 */
.ad-pop-enter-active {
  animation: adPop 0.4s cubic-bezier(0.34, 1.56, 0.64, 1); /* 回弹 */
}
@keyframes adPop {
  0% {
    transform: scale(0.5) translateY(40px);
    opacity: 0;
  }
  100% {
    transform: scale(1) translateY(0);
    opacity: 1;
  }
}

/* 高光划过 */
@keyframes adShine {
  0%, 60% {
    left: -80%;
  }
  100% {
    left: 130%;
  }
}

/* CTA 呼吸 */
@keyframes adBreath {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.04);
  }
}
</style>
